// « Complète ta commande · -15 % » (snippets/snk-cart-upsell.liquid). Après un ajout depuis le bloc (snk-card.js,
// attribut data-upsell, propriété _upsell), applique le code du réglage (PANIER15) : on AJOUTE le code aux codes déjà
// appliqués, on n'en retire jamais un. Si Shopify renvoie le code « applicable: false » :
// - avec un code du client applicable (non cumulable) : le code du client est gardé, le nôtre retiré, l'accessoire
//   reste au panier au prix normal, message « La remise -15 % ne se cumule pas avec ton code [CODE]. » ;
// - sans conflit (code inactif, expiré, désactivé) : le nôtre retiré, message « Le -15 % n'a pas pu s'appliquer à cet
//   article. » sous la ligne de l'article ajouté (jamais dans un encadré à part), le bloc se masque (plus de prix -15 %
//   affichés) pour la session sans message propre, et il réapparaît de lui-même
//   dès que le code redevient applicable : revérification au rendu suivant du tiroir, au plus une fois par minute et
//   seulement si un article du bloc est au panier (sans article éligible, Shopify répond « non applicable » quoi
//   qu'il arrive) ; jamais de requête en boucle.
// window.snkCartUpsell.applyAfterAdd(réponse de /cart/add.js) renvoie la réponse à rendre ; afterRender(réponse)
// pose le message après le rendu du tiroir.
(() => {
  const UNAVAILABLE = 'snkUpsellUnavailable';
  const CHECKED = 'snkUpsellChecked';
  const RECHECK_MS = 60000;
  const drawer = () => document.querySelector('cart-drawer');
  const upper = (c) => String(c || '').toUpperCase();
  const split = (value) => (value || '').split(',').map((c) => c.trim()).filter(Boolean);
  const store = {
    get: (key) => { try { return sessionStorage.getItem(key); } catch (error) { return null; } },
    set: (key, value) => { try { sessionStorage.setItem(key, value); } catch (error) { /* navigation privée : rien */ } },
    remove: (key) => { try { sessionStorage.removeItem(key); } catch (error) { /* idem */ } },
  };

  async function update(discount, withSections) {
    const cart = drawer();
    const body = { discount };
    if (withSections && cart) {
      body.sections = cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
    }
    const response = await fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || String(response.status));
    return result;
  }

  // Même rendu que cart-drawer.renderContents, sans ouvrir le tiroir
  function render(result) {
    const cart = drawer();
    if (!cart || !result.sections) return;
    cart.getSectionsToRender().forEach((section) => {
      const element = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (element && result.sections[section.id]) element.innerHTML = cart.getSectionInnerHTML(result.sections[section.id], section.selector);
    });
    cart.querySelector('#CartDrawer-Overlay')?.addEventListener('click', cart.close.bind(cart));
  }

  const applicable = (result, code) => (result.discount_codes || []).find((d) => upper(d.code) === upper(code))?.applicable === true;

  async function applyAfterAdd(added) {
    const block = document.querySelector('snk-cart-upsell');
    const code = block?.dataset.code;
    if (!code) return added;
    const applied = split(block.dataset.applied);
    const codes = applied.some((c) => upper(c) === upper(code)) ? applied : [...applied, code];
    let result = await update(codes.join(','), true);
    let conflict = null;
    let unavailable = false;
    if (applicable(result, code)) {
      store.remove(UNAVAILABLE);
    } else {
      // Le code du client passe avant le nôtre ; sans code du client, le nôtre n'est simplement pas disponible
      const kept = codes.filter((c) => upper(c) !== upper(code));
      result = await update(kept.join(','), true);
      conflict = kept.find((c) => applicable(result, c)) || null;
      unavailable = !conflict;
      if (unavailable) store.set(UNAVAILABLE, '1');
      else store.remove(UNAVAILABLE);
    }
    result.snkUpsellConflict = conflict;
    result.snkUpsellUnavailable = unavailable;
    result.snkUpsellVariantId = added?.variant_id || added?.items?.[0]?.variant_id || null;
    return result;
  }

  function setMessage(block, text) {
    const message = block.querySelector('[data-snk-upsell-message]');
    if (message) message.textContent = text;
  }

  // Message « n'a pas pu s'appliquer » sous la ligne de l'article qui vient d'être ajouté (jamais dans un encadré)
  function noteOnLine(variantId, text) {
    const cart = drawer();
    if (!cart || !variantId || !text) return;
    const input = cart.querySelector(`[data-quantity-variant-id="${variantId}"]`);
    const line = input?.closest('.cart-item');
    const details = line?.querySelector('.cart-item__details') || line;
    if (!details || details.querySelector('.snk-upsell__line-note')) return;
    const note = document.createElement('p');
    note.className = 'snk-upsell__line-note';
    note.setAttribute('role', 'status');
    note.textContent = text;
    details.appendChild(note);
  }

  // Après le rendu du tiroir : message de non-cumul sous le bloc, ou note sous la ligne et bloc masqué si le code
  // n'est pas disponible
  function afterRender(result) {
    const block = document.querySelector('snk-cart-upsell');
    if (result?.snkUpsellUnavailable) {
      noteOnLine(result.snkUpsellVariantId, block?.dataset.lineFailed || document.querySelector('[data-line-failed]')?.dataset.lineFailed || '');
      block?.unavailable();
      return;
    }
    if (!block) return;
    if (result?.snkUpsellConflict) setMessage(block, (block.dataset.conflict || '').replace('__CODE__', result.snkUpsellConflict));
  }

  window.snkCartUpsell = { applyAfterAdd, afterRender };

  if (!customElements.get('snk-cart-upsell')) {
    customElements.define(
      'snk-cart-upsell',
      class SnkCartUpsell extends HTMLElement {
        connectedCallback() {
          if (store.get(UNAVAILABLE) !== '1') return;
          this.unavailable();
          if (this.dataset.eligible !== '1') return;
          if (Date.now() - Number(store.get(CHECKED) || 0) < RECHECK_MS) return;
          store.set(CHECKED, String(Date.now()));
          this.recheck();
        }

        // Bloc masqué pour la session, sans message propre (le message est sur la ligne concernée)
        unavailable() {
          this.classList.add('is-unavailable');
          setMessage(this, '');
        }

        // Une vérification : le code redevenu applicable reste appliqué et le tiroir est re-rendu (bloc visible, lignes
        // remisées) ; sinon il est retiré sans re-rendu et le bloc reste masqué
        async recheck() {
          const code = this.dataset.code;
          const applied = split(this.dataset.applied);
          const codes = applied.some((c) => upper(c) === upper(code)) ? applied : [...applied, code];
          try {
            const result = await update(codes.join(','), true);
            if (applicable(result, code)) {
              store.remove(UNAVAILABLE);
              render(result);
            } else {
              await update(applied.join(','), false);
            }
          } catch (error) {
            console.error('Vérification du code -15 % :', error);
          }
        }
      }
    );
  }
})();
